import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {AsyncSubject, Observable} from 'rxjs';
import {filter, finalize, share, takeUntil} from 'rxjs/operators';
import {destroy$} from '../../destroyable';
import {OverlayService} from '../../overlay';
import {ModalService} from '../modal.service';
import {CONFIRM_COMMON_STRINGS} from './confirm-common-strings';

@Component({
    selector: 'confirm-modal',
    templateUrl: './confirm-modal.component.html',
    styleUrls: ['./confirm-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmModalComponent implements OnInit {

    @Input()
    public title: string;

    @Input()
    public titleTranslate: boolean = true;

    @Input()
    public message: string;

    @Input()
    public messageTranslate: boolean = true;

    @Input()
    public translationParams: {[key: string]: string} = null;

    @Input()
    public confirmButtonText: string = CONFIRM_COMMON_STRINGS.buttonConfirm;

    @Input()
    public cancelButtonText: string = CONFIRM_COMMON_STRINGS.buttonCancel;

    @Input()
    public onConfirmCallback: () => void;

    public choice$: Observable<boolean>;

    public readonly destroy$ = destroy$();

    private readonly choiceSubject$ = new AsyncSubject<boolean>();

    constructor(
        private modalService: ModalService,
        private clickOutsideService: OverlayService
    ) {
        this.initChoiceStream();
    }

    public ngOnInit(): void {
        this.createOverlay();
    }

    public close(): void {
        this.modalService.close(this);
    }

    public confirm(): void {
        if (this.onConfirmCallback) {
            this.onConfirmCallback();
        }

        this.choiceSubject$.next(true);
        this.choiceSubject$.complete();

        this.close();
    }

    private createOverlay(): void {
        this.clickOutsideService.create({
            target: this.modalService.getByInstance(this)
        }).subscribe(() => this.close());
    }

    private initChoiceStream(): void {
        this.choice$ = this.choiceSubject$.pipe(
            filter(choice => choice),
            takeUntil(this.destroy$),
            finalize(() => this.close()),
            share()
        );
    }

}
